import React from "react"

interface ToggleOptionProps {
  value: string | string[] | number,
  label: string,
  selected: boolean,
  onSelect: Function,
  activeClassName?: string,
  inactiveClassName?: string,
  buttonClassName?: string
}

class ToggleOptionInner extends React.Component<ToggleOptionProps> {
  static defaultProps: ToggleOptionProps = {
    value: "",
    label: "",
    selected: false,
    onSelect: () => {},
    inactiveClassName: "inline-block border-r border-gray-pure text-xl last:border-0 w-3/12 text-center",
    activeClassName: "inline-block border-r border-gray-pure text-xl last:border-0 w-3/12 text-center bg-black-secondary text-white",
    buttonClassName: "py-1.5",
  }

  constructor(props: ToggleOptionProps) {
    super(props)

    this.className = this.className.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  className() {
    const { selected, activeClassName, inactiveClassName } = this.props

    if (selected) {
      return activeClassName
    }

    return inactiveClassName
  }

  handleClick(event) {
    const { onSelect, value } = this.props
    event.preventDefault()
    onSelect(value)
  }

  render() {
    const { selected, label, buttonClassName } = this.props
    return (
      <li className={this.className()}>
        <button
          className={buttonClassName}
          onClick={this.handleClick}
          role="option"
          type="button"
          aria-selected={selected}
        >
          {label}
        </button>
      </li>
    )
  }
}

export function ToggleOption(props: ToggleOptionProps) {
  return <ToggleOptionInner {...props} />
}
